<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="login-container bg-light">
  <div class="login-box">
    <img src="assets/logo.svg" alt="logo" class="logo" />
    <h1 class="title"><span>T-Rex</span> Database</h1>

    <!--<div>-->
    <!--<h6 class="d-inline-block">v{{version}}</h6>-->
    <!--<div class="d-inline-block ml-3" ngbDropdown>-->
    <!--<button id="language-dropdown" class="btn btn-sm btn-secondary" ngbDropdownToggle>-->
    <!--{{currentLanguage}}-->
    <!--</button>-->
    <!--<div ngbDropdownMenu aria-labelledby="language-dropdown">-->
    <!--<button class="dropdown-item" *ngFor="let language of languages" (click)="setLanguage(language)">-->
    <!--{{language}}-->
    <!--</button>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <div class="container">
      <div class="col-md-4 mx-auto">
        <form (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
          <div class="login-title">
            {{ 'LOGIN.TITLE' | translate }}
          </div>

          <div class="form-group">
            <div class="relative">
              <label class="d-block">
                <input
                  type="text"
                  class="form-control"
                  formControlName="username"
                  autocomplete="email"
                  [placeholder]="'LOGIN.EMAIL' | translate"
                />
                <span hidden>{{ 'LOGIN.EMAIL' | translate }}</span>
                <small
                  [hidden]="loginForm.controls.username.valid || loginForm.controls.username.untouched"
                  class="text-danger"
                >
                  {{ 'LOGIN.EMAIL_VALIDATION_MSG' | translate }}
                </small>
              </label>
              <label class="d-block">
                <input
                  type="password"
                  class="form-control"
                  formControlName="password"
                  autocomplete="password"
                  [placeholder]="'LOGIN.PASSWORD' | translate"
                  required
                />
                <span hidden>{{ 'LOGIN.PASSWORD' | translate }}</span>
                <small
                  [hidden]="loginForm.controls.password.valid || loginForm.controls.password.untouched"
                  class="text-danger"
                >
                  {{ 'LOGIN.PASSWORD_VALIDATION_MSG' | translate }}
                </small>
              </label>
              <button class="btn btn-primary btn-login" type="submit" [disabled]="loginForm.invalid || isLoading">
                <i class="fas fa-cog fa-spin" [hidden]="!isLoading"></i>
                <span>{{ 'LOGIN.LOGIN_BTN' | translate }}</span>
              </button>
            </div>
            <div class="form-bottom">
              <div class="form-check">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input" formControlName="remember" />
                  <span>{{ 'LOGIN.REMEMBER_ME_CHECKBOX' | translate }}</span>
                </label>
              </div>
              <div>
                <a href="#" class="form-bottom-link">{{ 'LOGIN.FORGOTTEN_PASSWORD' | translate }}</a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
